module.exports = __webpack_public_path__ + "static/media/left-arrow.67f8c256.svg";